import { render, staticRenderFns } from "./newUpload.vue?vue&type=template&id=b87d672e&scoped=true"
import script from "./newUpload.vue?vue&type=script&lang=js"
export * from "./newUpload.vue?vue&type=script&lang=js"
import style0 from "./newUpload.vue?vue&type=style&index=0&id=b87d672e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87d672e",
  null
  
)

export default component.exports